// import React from 'react';
import styled, { css } from 'styled-components';

const twoColumns = css`
  display: flex;
  justify-content: space-between;
  & > * {
    flex: 0 0 calc(50% - 10px);
  }
`;

const twoColumnsResponsive = css`
  @media (min-width: 576px) {
    ${twoColumns};
  }
`;

const TwoColumns = styled.div`
  ${(p) => p.responsive ? twoColumnsResponsive : twoColumns}
`;

export default TwoColumns;
